import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import propertyMarketInsightsService from '../services/property-market-insights.service';

export function usePropertyPriceTrendQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => ['property', propertyId.value, 'price-trend'],
    query: () => propertyMarketInsightsService.getPriceTrend(propertyId.value),
  });
}

export function usePropertyComparableRentalsQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => ['property', propertyId.value, 'comparable-rentals'],
    query: () => propertyMarketInsightsService.getComparableRentals(propertyId.value),
  });
}

export function usePropertyRentEstimateQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => ['property', propertyId.value, 'rent-estimate'],
    query: () => propertyMarketInsightsService.getRentEstimate(propertyId.value),
  });
}
